import { vStyle } from '#core/directives/style'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.directive('style', vStyle)
})
